module.exports = __webpack_public_path__ + "img/lnr-upload.72ebae7c.svg";